import { makeStyles } from '@material-ui/core/styles'
import LandingPageBGImage from '../../images/bglandingpage2x.png'
const useStyles = makeStyles(
  () => ({
    background: {
      backgroundImage: `url(${LandingPageBGImage})`,
      /* Center and scale the image nicely */
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 910px',
      /* Full height */
      height: '100vh',
      '@media (min-height: 1000px)': {
        backgroundSize: '100% 100%',
      },
    },
  }),
  { index: 1 },
)

export { useStyles }
